import { render } from "./ProjectFinancialDashboard.vue?vue&type=template&id=dd736eb2&scoped=true&ts=true"
import script from "./ProjectFinancialDashboard.vue?vue&type=script&lang=ts"
export * from "./ProjectFinancialDashboard.vue?vue&type=script&lang=ts"

import "./ProjectFinancialDashboard.vue?vue&type=style&index=0&id=dd736eb2&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd736eb2"]])

export default __exports__